import { render, staticRenderFns } from "./LogsTabs.vue?vue&type=template&id=240cbb78&"
import script from "./LogsTabs.vue?vue&type=script&lang=js&"
export * from "./LogsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports